if (!Array.from) {
  Array.from = (function () {
    var symbolIterator;
    try {
      symbolIterator = Symbol.iterator ? Symbol.iterator : "Symbol(Symbol.iterator)";
    } catch (e) {
      symbolIterator = "Symbol(Symbol.iterator)";
    }

    var toStr = Object.prototype.toString;
    var isCallable = function (fn) {
      return typeof fn === "function" || toStr.call(fn) === "[object Function]";
    };
    var toInteger = function (value) {
      var number = Number(value);
      if (isNaN(number)) return 0;
      if (number === 0 || !isFinite(number)) return number;
      return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
    };
    var maxSafeInteger = Math.pow(2, 53) - 1;
    var toLength = function (value) {
      var len = toInteger(value);
      return Math.min(Math.max(len, 0), maxSafeInteger);
    };

    var setGetItemHandler = function setGetItemHandler(isIterator, items) {
      var iterator = isIterator && items[symbolIterator]();
      return function getItem(k) {
        return isIterator ? iterator.next() : items[k];
      };
    };

    var getArray = function getArray(T, A, len, getItem, isIterator, mapFn) {
      // 16. Let k be 0.
      var k = 0;

      // 17. Repeat, while k < len… or while iterator is done (also steps a - h)
      while (k < len || isIterator) {
        var item = getItem(k);
        var kValue = isIterator ? item.value : item;

        if (isIterator && item.done) {
          return A;
        } else {
          if (mapFn) {
            A[k] = typeof T === "undefined" ? mapFn(kValue, k) : mapFn.call(T, kValue, k);
          } else {
            A[k] = kValue;
          }
        }
        k += 1;
      }

      if (isIterator) {
        throw new TypeError("Array.from: provided arrayLike or iterator has length more then 2 ** 52 - 1");
      } else {
        A.length = len;
      }

      return A;
    };

    // The length property of the from method is 1.
    return function from(arrayLikeOrIterator /*, mapFn, thisArg */) {
      // 1. Let C be the this value.
      var C = this;

      // 2. Let items be ToObject(arrayLikeOrIterator).
      var items = Object(arrayLikeOrIterator);
      var isIterator = isCallable(items[symbolIterator]);

      // 3. ReturnIfAbrupt(items).
      if (arrayLikeOrIterator == null && !isIterator) {
        throw new TypeError("Array.from requires an array-like object or iterator - not null or undefined");
      }

      // 4. If mapfn is undefined, then let mapping be false.
      var mapFn = arguments.length > 1 ? arguments[1] : void undefined;
      var T;
      if (typeof mapFn !== "undefined") {
        // 5. else
        // 5. a If IsCallable(mapfn) is false, throw a TypeError exception.
        if (!isCallable(mapFn)) {
          throw new TypeError("Array.from: when provided, the second argument must be a function");
        }

        // 5. b. If thisArg was supplied, let T be thisArg; else let T be undefined.
        if (arguments.length > 2) {
          T = arguments[2];
        }
      }

      // 10. Let lenValue be Get(items, "length").
      // 11. Let len be ToLength(lenValue).
      var len = toLength(items.length);

      // 13. If IsConstructor(C) is true, then
      // 13. a. Let A be the result of calling the [[Construct]] internal method
      // of C with an argument list containing the single item len.
      // 14. a. Else, Let A be ArrayCreate(len).
      var A = isCallable(C) ? Object(new C(len)) : new Array(len);

      return getArray(T, A, len, setGetItemHandler(isIterator, items), isIterator, mapFn);
    };
  })();
}

var WDN = WDN || {};

if (typeof WDN.Money === "undefined") {
  WDN.Money = (function () {
    var FormatMoney = function (price) {
      return theme.Currency.formatMoney(price, theme.moneyFormat);
    };

    return {
      Format: FormatMoney,
    };
  })();
}

/* Gallery thumbs */
if (typeof WDN.ProductGallery === "undefined") {
  WDN.ProductGallery = (function () {
    var init, bind, windowOnResize, setSwiperDirection, setInitialState;
    var setThumbsDirectionBasedOnScreen;

    var nodes = {
      main_gallery_thumbs: document.querySelector("wdn-swiper[data-id='product_page-thumbs']"),
    };

    var config = {
      md_up_bp: 880,
    };

    var states = {};

    setSwiperDirection = function (newDirection) {
      var currentDirection = states.main_gallery_thumbs_direction;
      if (currentDirection == newDirection) return;
      nodes.main_gallery_thumbs.Swiper.changeDirection(newDirection, true);
      states.main_gallery_thumbs_direction = newDirection;
    };

    setThumbsDirectionBasedOnScreen = function () {
      if (window.innerWidth >= config.md_up_bp) {
        setSwiperDirection("vertical");
      } else {
        setSwiperDirection("horizontal");
      }
    };

    windowOnResize = function () {
      setThumbsDirectionBasedOnScreen();
    };

    bind = function () {
      window.addEventListener("window:resize", windowOnResize);
    };

    setInitialState = function () {
      setThumbsDirectionBasedOnScreen();
    };

    init = function () {
      nodes.main_gallery_thumbs = document.querySelector("wdn-swiper[data-id='product_page-thumbs']");
      if (!nodes.main_gallery_thumbs) return;
      states.main_gallery_thumbs_direction = nodes.main_gallery_thumbs.Swiper.params.direction;
      setInitialState();
      bind();
    };

    /* Gallery Async */
    new WDN.SectionRenderer({
      selectors: {
        output: "[data-product-gallery-content]",
      },
      sections: ["async-product-gallery"],
      useCurrentRoot: true,
      stripWrapper: true,
      triggers: [window],
      events: ["DOMContentLoaded"],
      callback: function () {
        WDN.ZoomImages.init();

        /* Thumbs ASYNC LOAD */
        new WDN.SectionRenderer({
          selectors: {
            output: "[data-gallery-thumbs]",
          },
          sections: ["async-product-gallery-thumbs"],
          useCurrentRoot: true,
          replaceOutput: true,
          autoInit: true,
          callback: function () {
            var ProductPageSwiper = document.querySelector("wdn-swiper[data-id='product_page']");
            if (!ProductPageSwiper) return;
            ProductPageSwiper.init();
            init();
          },
        });
      },
    });

    return {};
  })();
}

class WDNProductPage extends WDN.Component {
  constructor() {
    super();
    this.config = {};
    this.nodes = {
      pricings_wrappers: document.querySelectorAll("[data-product-pricing]"),
      price_containers: document.querySelectorAll("[data-product-price]"),
      lineprice_containers: document.querySelectorAll("[data-product-singleline-price]"),
      compare_price_containers: document.querySelectorAll("[data-product-compareprice]"),
      variant_containers: document.querySelectorAll("[data-product-variant]"),
      discount_containers: document.querySelectorAll("[data-product-savings]"),
      variant_select: this.querySelector("wdn-variant-select"),
      quantity_select: this.querySelector("wdn-quantity"),
      stock_containers: document.querySelectorAll("[data-product-stock]"),
      stock_count_containers: document.querySelectorAll("[data-product-stockcount]"),
      submit_button: document.querySelector('[data-form-submit="product_page"]'),
    };

    this.selectedVariant = this.getSelectedVariant();
    this.init();
  }

  setUnitPricing(quantity) {
    var unitJSONDumpTarget = document.querySelector("[data-product-bulk-discount]");

    if (!unitJSONDumpTarget) {
      this.unitPricing = false;
      return;
    }
    this.unitPricing = true;
    this.unitPricingDataList = JSON.parse(unitJSONDumpTarget.text);
  }

  getUnitConfigForQty(quantity) {
    if (!this.unitPricing || quantity == 1) {
      return false;
    }

    if (quantity - 1 > this.unitPricingDataList.length) {
      quantity = this.unitPricingDataList.length + 1;
    }

    let selectedPrice = this.selectedVariant.price,
      selectedDiscount = selectedPrice * this.unitPricingDataList[quantity - 2].unitSavingsFactor,
      selectedObject = {
        unitPrice: selectedPrice - selectedDiscount,
        unitSavings: selectedDiscount,
        unitSavingsFactor: this.unitPricingDataList[quantity - 2].unitSavingsFactor,
        unitSavingsPercentage: this.unitPricingDataList[quantity - 2].unitSavingsPercentage,
      };

    return selectedObject;
  }

  updateBundleQuantities() {
    let quantityUnitPrices = document.querySelectorAll(".bundle-quantity__price-amount");

    if (this.unitPricingDataList) {
      quantityUnitPrices.forEach((unit, index) => {
        let newPrice = this.selectedVariant.price - this.selectedVariant.price * this.unitPricingDataList[index].unitSavingsFactor;

        unit.textContent = WDN.Money.Format(newPrice);
      });
    }
  }

  insertInNodeList(content, nodeList) {
    nodeList.forEach(function (node) {
      node.innerHTML = content;
    });
  }

  setNodeListState(newState, nodeList) {
    nodeList.forEach(function (node) {
      node.setAttribute("data-state", newState);
    });
  }

  disableSubmit() {
    this.nodes.submit_button.disabled = true;
  }

  enableSubmit() {
    this.nodes.submit_button.disabled = false;
  }

  getSelectedVariant() {
    return this.nodes.variant_select.selectedVariant;
  }

  reassignNodes() {
    this.nodes.pricings_wrappers = document.querySelectorAll("[data-product-pricing]");
    this.nodes.price_containers = document.querySelectorAll("[data-product-price]");
    this.nodes.lineprice_containers = document.querySelectorAll("[data-product-singleline-price]");
    this.nodes.compare_price_containers = document.querySelectorAll("[data-product-compareprice]");
  }

  setLinePrice(linePrice) {
    this.reassignNodes();
    this.insertInNodeList(linePrice, this.nodes.lineprice_containers);
  }

  setPrice(newPrice) {
    this.reassignNodes();
    this.insertInNodeList(newPrice, this.nodes.price_containers);
  }

  setComparePrice(newComparePrice) {
    this.reassignNodes();
    this.insertInNodeList(newComparePrice, this.nodes.compare_price_containers);
  }

  setURLParam() {
    this.currentParams = new URLSearchParams(window.location.search);
    this.currentParams.set("variant", this.selectedVariant.id);
    window.history.replaceState("", "", "?" + this.currentParams.toString());
  }

  setSavings(newSavings) {
    this.insertInNodeList(Math.round(newSavings) + "%", document.querySelectorAll(".product__page .badge--discount .badge-label"));
    this.insertInNodeList(Math.round(newSavings) + "%", this.nodes.discount_containers);
  }

  calculateSavings() {
    var compare_at_price = this.selectedVariant.compare_at_price || 0;
    var linePrice = this.selectedVariant.price;

    if (this.unitPricing) {
      this.discountedPrices = this.getUnitConfigForQty(this.nodes.quantity_select.value);

      if (this.discountedPrices) {
        if (compare_at_price === 0) {
          compare_at_price = this.selectedVariant.price;
        }
        linePrice = this.discountedPrices.unitPrice;
      }
    }

    if (compare_at_price === 0) {
      this.setNodeListState("default", this.nodes.pricings_wrappers);
      return 0;
    }

    this.setNodeListState("on_sale", this.nodes.pricings_wrappers);
    return 100 - (linePrice / compare_at_price) * 100;
  }

  updateStockStatus() {
    var variantStock = this.nodes.variant_select.selectedVariant_stock;
    if (!variantStock) return;
    this.setNodeListState(variantStock.status, this.nodes.stock_containers);
    this.insertInNodeList(variantStock.count, this.nodes.stock_count_containers);
  }

  outputVariantTitle() {
    var content = this.selectedVariant.title;
    if (content == "Default Title") {
      content = "";
    }
    this.insertInNodeList(content, this.nodes.variant_containers);
  }

  validateQuantity() {
    var quantity_select = this.nodes.quantity_select;
    var stockCount = this.nodes.variant_select.selectedVariant_stock.count;
    quantity_select.max = stockCount;
    if (quantity_select.value > stockCount) {
      quantity_select.set(stockCount);
    }
    quantity_select.validateQuantity();
  }

  outputPrices() {
    if (!this.selectedVariant) return;
    var quantity_value = this.nodes.quantity_select.value;
    var price_calc = this.selectedVariant.price * quantity_value;
    var compare_calc = this.selectedVariant.compare_at_price || 0;
    var linePrice = this.selectedVariant.price;

    if (this.unitPricing) {
      this.discountedPrices = this.getUnitConfigForQty(quantity_value);

      if (this.discountedPrices) {
        price_calc = this.discountedPrices.unitPrice * quantity_value;
        linePrice = this.discountedPrices.unitPrice;

        if (compare_calc === 0) {
          compare_calc = this.selectedVariant.price;
        }
      }
    }

    this.setLinePrice(WDN.Money.Format(linePrice));
    this.setPrice(WDN.Money.Format(price_calc));
    this.setComparePrice(WDN.Money.Format(compare_calc));
  }

  onVariantChange() {
    var selectedVariant = this.getSelectedVariant();
    if (!selectedVariant) {
      this.disableSubmit();
      return;
    }
    this.setUnitPricing();
    this.selectedVariant = selectedVariant;
    this.outputPrices();
    this.setSavings(this.calculateSavings());
    this.updateStockStatus();
    this.outputVariantTitle();
    this.setURLParam();
    this.validateQuantity();
    this.updateBundleQuantities();
  }

  onQuantityChange(e) {
    if (e.detail.id !== "product_page") return;
    this.outputPrices();
    this.setSavings(this.calculateSavings());
  }
  variantSelectOnInit() {
    this.onVariantChange();
  }

  setCallbacks() {
    this.nodes.variant_select.onInit = this.variantSelectOnInit.bind(this);
    this.nodes.variant_select.onVariantChange = this.onVariantChange.bind(this);
    this.bindElement(document.body, "quantity:change", this.onQuantityChange.bind(this));
  }

  setInitialState() {
    this.onVariantChange();
  }

  init() {
    this.setCallbacks();
  }
}

customElements.define("wdn-product-page", WDNProductPage);

class WDNBundleQuantity extends WDN.Component {
  constructor() {
    super();
    this.id = this.getAttribute("data-id");
    this.isActive = this.getAttribute("data-active") == "";
    this.quantity = parseInt(this.getAttribute("data-value"));
    this.quantity_select = document.querySelector("[data-product-quantity]");
    this.quantity_select_value = this.quantity_select.get();
    this.init();
  }

  getActiveTab() {
    return document.querySelector("wdn-bundle-quantity[data-id='" + this.id + "'][data-active]");
  }

  deslectOtherTabs() {
    var activeTab = this.getActiveTab();
    if (!activeTab || activeTab == this) return;
    activeTab.setState(false);
  }

  setState(newState) {
    if (newState) {
      this.setAttribute("data-active", "");
    } else {
      this.removeAttribute("data-active");
    }
    this.isActive = newState;
  }

  onQuantityChange() {
    this.quantity_select_value = this.quantity_select.get();
    this.setState(this.quantity_select_value == this.quantity);
  }

  onQuantitySelectChange() {
    this.fireEvent({
      name: "bundle:quantity:change",
      detail: {},
    });
  }

  setQuantity() {
    var value = this.isActive ? this.quantity : 1;
    this.quantity_select.set(value);
  }

  onClick() {
    this.deslectOtherTabs();
    this.setState(!this.isActive);
    this.setQuantity();
  }

  setCallbacks() {
    this.quantity_select.onQuantityChange = this.onQuantitySelectChange.bind(this);
  }

  bind() {
    this.bindElement(this, "click", this.onClick.bind(this));
    this.bindElement(document.body, "bundle:quantity:change", this.onQuantityChange.bind(this));
  }

  init() {
    this.setCallbacks();
    this.bind();
  }
}

customElements.define("wdn-bundle-quantity", WDNBundleQuantity);

class WDNGalleryTrigger extends WDN.Component {
  constructor() {
    super();
    this.wdn_swiper = document.querySelector("wdn-swiper[data-id='product_page']");
    this.productId = this.getAttribute("data-product-id");
    this.productHandle = this.getAttribute("data-product-handle");
    this.modal = document.querySelector("wdn-modal[data-id='product_gallery']");
    this.layout_container = this.modal.querySelector("[data-modal-gallery]");
    this.isRendered = false;
    this.init();
  }

  assignNewNodes() {
    if (this.modal_swiper) return;
    this.modal_swiper = this.layout_container.querySelector('wdn-swiper[data-id="product_modal_gallery"]');
  }

  setSameActiveSlide() {
    var page_swiper = this.wdn_swiper.Swiper;
    if (!page_swiper) return;
    var modal_swiper = this.modal_swiper.Swiper;
    modal_swiper.slideTo(page_swiper.activeIndex, 0);
  }

  onFetchSuccess(res) {
    this.layout_container.innerHTML = res;
    this.isRendered = true;
    this.fireEvent({
      name: "gallery:loaded",
    });
    this.assignNewNodes();
    this.setSameActiveSlide();
    this.modal.open();
  }

  onFetchError() {}

  fetchGallery() {
    this.Request.Get({
      url: Shopify.routes.root + "products/" + this.productHandle + "?section_id=template-product-modal-swiper",
      onSuccess: this.onFetchSuccess.bind(this),
      onError: this.onFetchError.bind(this),
    });
  }

  onClick() {
    if (window.innerWidth < 880) return;
    if (!this.isRendered) {
      this.fetchGallery();
      this.dispatchEvent(new Event("gallery:fetched"));
    } else {
      this.setSameActiveSlide();
      this.modal.open();
    }
  }

  onLoadEvent() {
    if (this.isRendered) return;
    this.isRendered = true;
    this.assignNewNodes();
  }

  bind() {
    this.bindElement(this, "click", this.onClick.bind(this));
    this.bindElement(document.body, "gallery:loaded", this.onLoadEvent.bind(this));
  }

  init() {
    this.bind();
  }
}

customElements.define("wdn-gallery-trigger", WDNGalleryTrigger);

class WDNModalQuantity extends WDN.Component {
  constructor() {
    super();
    this.variant_select = document.querySelector("[data-variant-select]");
    this.quantity_module = document.querySelector("[data-product-quantity]");
    this.checkboxes = this.querySelectorAll("wdn-checkbox");
    this.final_quantity_indicators = document.querySelectorAll("[data-final-quantity]");
    this.modal_submit = this.querySelector("[data-modal-submit]");
    this.main_submit = document.querySelector('[data-form-submit="product_page"]');
    this.init();
  }

  disableSubmit(newState) {
    this.modal_submit.disabled = newState;
  }

  onCheckboxChange(activeCheckbox) {
    this.quantity_module.set(activeCheckbox.value);
    this.outputFinalQuantity(activeCheckbox.value);
  }

  outputFinalQuantity(value) {
    this.final_quantity_indicators.forEach(function (indicator) {
      indicator.innerHTML = value;
      if (indicator.value) {
        indicator.value = value;
      }
    });
  }

  setupCallbacks() {
    this.checkboxes.forEach(function (checkbox) {
      checkbox.onChange = this.onCheckboxChange.bind(this);
    }, this);
  }

  setInitialState() {
    this.refreshSubmitState();
  }

  refreshSubmitState() {
    var newState = this.variant_select.selectedVariant;
    if (newState) {
      newState = this.variant_select.selectedVariant.available;
    }

    this.disableSubmit(!newState);
  }

  selectLastAvailCheckbox(stockCount) {
    var i = this.checkboxes.length - 1;
    var firstCheckbox = this.checkboxes[0];

    for (i; i >= 0; i--) {
      var checkbox = this.checkboxes[i];
      if (checkbox && !checkbox.isDisabled && stockCount >= checkbox.value) {
        var selectedCheckbox = checkbox;
        checkbox.click();
        break;
      }
    }

    if (!selectedCheckbox && firstCheckbox) {
      firstCheckbox.setState(true);
      this.onCheckboxChange(firstCheckbox);
    }
  }

  validateCheckboxesBasedOnStock() {
    var variant_select = this.variant_select;
    if (!variant_select.selectedVariant) return;
    var variant_stock_count = variant_select.selectedVariant_stock.count;
    this.checkboxes.forEach(function (checkbox) {
      if (checkbox.value > variant_stock_count) {
        checkbox.disable();
        if (checkbox.isChecked) {
          checkbox.setState(false);
          this.selectLastAvailCheckbox(variant_stock_count);
        }
      } else {
        checkbox.enable();
      }
    }, this);
  }

  onVariantSelect(e) {
    var variant_select = e.detail;
    if (variant_select.id !== "product_page") return;
    this.validateCheckboxesBasedOnStock();
    this.refreshSubmitState();
  }

  onVariantSelectInit(e) {
    this.onVariantSelect(e);
  }

  modal_submitOnClick() {
    var selected_variant = this.variant_select.selectedVariant;
    if (selected_variant && selected_variant.available) {
      this.main_submit.click();
    }
  }

  validateCheckboxesBasedOnQuantity(newQuantity) {
    this.checkboxes.forEach(function (checkbox) {
      checkbox.setState(checkbox.value == newQuantity);
    });
  }

  onQuantityChange(e) {
    var quantity_module = e.detail;
    if (quantity_module.id != "product_page") return;
    this.validateCheckboxesBasedOnQuantity(quantity_module.value);
    this.outputFinalQuantity(quantity_module.value);
  }

  bindCustomQuantityFromClient() {
    var inputQty = document.querySelector("[data-client-manual-quantity]");

    inputQty.addEventListener("change", () => {
      this.validateCheckboxesBasedOnQuantity(inputQty.value);
      this.outputFinalQuantity(inputQty.value);
      this.quantity_module.set(inputQty.value);
    });
  }

  bind() {
    this.bindElement(document.body, "variant:selected", this.onVariantSelect.bind(this));
    this.bindElement(document.body, "variant_select:initted", this.onVariantSelectInit.bind(this));
    this.bindElement(document.body, "quantity:change", this.onQuantityChange.bind(this));
    this.bindElement(this.modal_submit, "click", this.modal_submitOnClick.bind(this));
    this.bindCustomQuantityFromClient();
  }
  init() {
    this.setInitialState();
    this.setupCallbacks();
    this.bind();
  }
}

customElements.define("wdn-modal-quantity", WDNModalQuantity);

class WDNModalVariantSelect extends WDNModalOpen {
  constructor() {
    super();
    this.config = {
      modal_id: this.getAttribute("data-id"),
      sections: this.getAttribute("data-sections"),
      output_selector: this.getAttribute("data-output"),
      product_handle: this.getAttribute("data-handle"),
      option_name: this.getAttribute("data-option-name"),
      main_variant_id: "product_page",
      main_quantity_id: "product_page",
      quantity_id: "mobile_variant_select",
      variant_id: "mobile_variant_select",
    };

    this.dependencies = {
      routes: WDN.Routes,
      request: WDN.Request,
    };
    this.nodes = {};
    this.states = {
      isFetching: false,
      hasContent: false,
    };
    this.init();
  }

  updateModalConfig() {}

  toggleContentByOptionName() {
    this.nodes.option_name_containers.forEach(function (container) {
      var name = container.getAttribute("data-name-container");
      if (name == this.config.option_name) {
        container.classList.remove("hidden");
      } else {
        container.classList.add("hidden");
      }
    }, this);
  }

  handleClickAction() {
    this.toggleContentByOptionName();
    if (this.action === "close") {
      this.element.close();
      this.callback("onClose");
    }
    if (this.action === "open") {
      this.element.open();
      this.callback("onOpen");
    }
  }

  onFetchError() {
    this.states.isFetching = false;
  }

  output_sections(sections) {
    var output_data = [];
    for (var key in sections) {
      if (sections.hasOwnProperty(key)) {
        output_data.push(sections[key]);
      }
    }
    this.nodes.output_container.insertAdjacentHTML("beforeend", output_data.join(""));
  }

  assignFetchedNodes() {
    var config = this.config;
    this.nodes.modal_variant_selects = this.element.querySelectorAll("[data-select]");
    this.nodes.option_name_containers = this.element.querySelectorAll("[data-name-container]");
    this.nodes.modal_submit = this.element.querySelector("[data-modal-submit]");
    this.nodes.modal_quantity_module = this.element.querySelector("[data-product-quantity][id='" + config.quantity_id + "']");
  }

  bindFetchedNodes() {
    var nodes = this.nodes;
    this.bindElement(nodes.modal_submit, "click", this.modalSubmitOnClick.bind(this));
  }

  modalSubmitOnClick(e) {
    e ? e.preventDefault() : "";
    if (!this.getSelectedVariant()) return;
    this.nodes.main_submit.click();
  }

  adjustModalQuantity() {
    var nodes = this.nodes;
    var modal_quantity_module = nodes.modal_quantity_module;
    var main_quantity_module = nodes.main_quantity;
    if (!modal_quantity_module) return;
    var modules_match = modal_quantity_module.value == main_quantity_module.value && modal_quantity_module.max == main_quantity_module.max;
    if (modules_match) return;
    modal_quantity_module.max = main_quantity_module.max;
    modal_quantity_module.set(main_quantity_module.value);
  }

  onFetchSuccess(res) {
    this.states.isFetching = false;
    this.states.hasContent = true;
    this.output_sections(res);
    this.assignFetchedNodes();
    this.bindFetchedNodes();
    this.fireEvent({ name: "modal_variant:fetched", detail: this });
    this.adjustModalQuantity();
    this.handleClickAction();

    // Bind click to size guide inside variant select
    new WDN.SectionRenderer({
      selectors: {
        trigger: "wdn-modal-open[data-id='product-size-visual']",
        output: "[data-sizeguide-modal-content]",
      },
      sections: ["async-product-size-modal"],
      useCurrentRoot: true,
      replaceOutput: true,
      events: ["click"],
      callback: WDN.ProductSizeGuide.handleSizeGuideInject,
    });

    // Same thing for quantity modal
    if (document.querySelector("[data-quantity-modal-content] wdn-modal-quantity")) return;
    new WDN.SectionRenderer({
      selectors: {
        trigger: "wdn-modal-open[data-id='product_quantity']",
        output: "[data-quantity-modal-content]",
      },
      sections: ["async-product-quantity-modal"],
      useCurrentRoot: true,
      replaceOutput: true,
      events: ["click"],
    });
  }

  getSelectedVariant() {
    var selected_variant = false;
    this.nodes.main_selects.forEach(function (select) {
      if (select.selectedVariant) {
        selected_variant = select.selectedVariant;
      }
    });
    return selected_variant;
  }

  generateFetchUrl() {
    var config = this.config;
    var selected_variant = this.getSelectedVariant();
    var url = this.dependencies.routes.root_url + "products/" + config.product_handle + "?sections=" + config.sections;
    if (selected_variant) {
      url = url + "&variant=" + selected_variant.id;
    }

    return url;
  }

  fetchRequestedSections() {
    this.states.isFetching = true;
    this.dependencies.request.Get({
      url: this.generateFetchUrl(),
      type: "JSON",
      onSuccess: this.onFetchSuccess.bind(this),
      onError: this.onFetchError.bind(this),
    });
  }

  handleClick() {
    if (this.states.isFetching) return;
    if (this.states.hasContent) {
      this.handleClickAction();
    } else {
      this.fetchRequestedSections();
    }
  }

  onQuantityChange(e) {
    var quantity_module = e.detail;
    var nodes = this.nodes;
    switch (quantity_module.id) {
      case "product_page":
        this.adjustModalQuantity();
        break;
      case this.config.quantity_id:
        nodes.main_quantity.set(quantity_module.value);
        break;
        return;
    }
  }

  reflectChangeOnMainSelects(variant_module) {
    if (!variant_module.selected_option) return;
    this.nodes.main_selects.forEach(function (select) {
      select.setActiveOptionByValue(variant_module.selected_option.value);
      select.onOptionSelect();
    });
  }

  onVariantChange(e) {
    var variant_module = e.detail;
    var config = this.config;
    var selected_variant = variant_module.selectedVariant;
    var selected_variant_stock = variant_module.selectedVariant_stock;

    if (variant_module._id != config.variant_id) return;
    this.reflectChangeOnMainSelects(variant_module);
    if (!selected_variant || !selected_variant_stock) return;

    this.adjustModalQuantity();
  }

  onFetchSuccessEvent(e) {
    var element = e.detail;
    if (element == this) return;
    // merging data
    this.nodes = element.nodes;
    this.states = element.states;
  }

  onOptionSelect(e) {
    var select = e.detail;
    if (select.id !== this.config.variant_id) return;
    this.reflectChangeOnMainSelects(select);
  }

  setupCallbacks() {
    this.bindElement(document.body, "modal_variant:fetched", this.onFetchSuccessEvent.bind(this));
    this.bindElement(document.body, "quantity:change", this.onQuantityChange.bind(this));
    this.bindElement(document.body, "option:selected", this.onOptionSelect.bind(this));
    this.bindElement(document.body, "variant:selected", this.onVariantChange.bind(this));
  }

  assignNodes() {
    this.nodes = {
      output_container: document.querySelector(this.config.output_selector),
      main_selects: document.querySelectorAll("[data-select][data-id='" + this.config.main_variant_id + "']"),
      main_quantity: document.querySelector("[data-product-quantity][id='" + this.config.main_quantity_id + "']"),
      main_submit: document.querySelector("[data-form-submit='" + this.config.main_variant_id + "']"),
      modal_variant_selects: [],
    };
  }

  init() {
    this.updateModalConfig();
    this.assignNodes();
    this.setupCallbacks();
  }
}

customElements.define("wdn-modalvariant-trigger", WDNModalVariantSelect);

if (typeof WDN.ProductTabs === "undefined") {
  WDN.ProductTabs = (function () {
    var init, assign_nodes, validate_links, hide_link;

    var nodes = {
      main_container: document.querySelector("[data-product-tabs]"),
    };

    assign_nodes = function () {
      nodes.links = nodes.main_container.querySelectorAll("wdn-scroll-link");
    };

    hide_link = function (link) {
      var link_parent = link.parentNode;
      link_parent.classList.add("hidden");
    };

    validate_links = function () {
      nodes.links.forEach(function (link) {
        if (!link.target) {
          hide_link(link);
        }
      });
    };

    init = function () {
      if (!nodes.main_container) return;
      assign_nodes();
      validate_links();
    };

    init();

    return {};
  })();
}

if (typeof WDN.ProductStickyAdd === "undefined") {
  WDN.ProductStickyAdd = (function () {
    var init, bind, active;
    var fetch_section;
    // callbacks
    var onNodeReach, onNodeLeave, onFetchSuccess, onFetchError;

    var nodes = {
      body: document.body,
      handle_container: document.querySelector("[data-productpage-handle]"),
    };

    if (!nodes.handle_container) return;

    var config = {
      node_id: "product_sticky_add",
      active_class: "product-sticky-active",
      section_id: "product_page-quickshop"
    };

    var data = {
      product_handle: nodes.handle_container.getAttribute("data-productpage-handle"),
      variant_id: nodes.handle_container.getAttribute("data-productpage-variant-id"),
      fetched_section: false,
      is_fetching: false,
    };

    var dependencies = {
      Request: WDN.Request,
      Routes: WDN.Routes,
    };

    active = function (state) {
      var body_classlist = nodes.body.classList;
      if (state) {
        body_classlist.add(config.active_class);
      } else {
        body_classlist.remove(config.active_class);
      }
    };

    onFetchSuccess = function (res) {
      data.is_fetching = false;
      data.fetched_section = res;
      nodes.body.insertAdjacentHTML("beforeend", res);
      if (typeof SmartWishlistMain === "function") {
        SmartWishlistMain();
      }
      
      document.body.dispatchEvent(new CustomEvent("section_loaded:" + config.node_id));
    };

    onFetchError = function () {
      data.is_fetching = false;
    };

    fetch_section = function () {
      var variant_id = "";
      if (data.variant_id.length > 0) variant_id += "&variant=" + data.variant_id;
      
      if (data.is_fetching) return;
      data.is_fetching = true;
      dependencies.Request.Get({
        url: dependencies.Routes.root_url + "products/" + data.product_handle + "?section_id=" + config.section_id + variant_id,
        onSuccess: onFetchSuccess,
        onError: onFetchError,
      });
    };

    onNodeReach = function () {
      if (data.fetched_section) {
        // show element
      } else {
        // fetch element
        fetch_section();
      }
      active(true);
    };

    onNodeLeave = function () {
      active(false);
    };

    bind = function () {
      document.body.addEventListener("reached:" + config.node_id, onNodeReach);
      document.body.addEventListener("left:" + config.node_id, onNodeLeave);
    };

    init = function () {
      bind();
    };

    init();
  })();
}

(function() {
  var scrollTop = () => {
    var top = 0;
  

    if (window.innerWidth < 900) {
      var 
        rect = document.querySelector('.productpage-form').getBoundingClientRect(),
        scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      
      top = rect.top + scrollTop - 150;
    }
    
    scroll({
      top: top,
      behavior: "smooth"
    });
  }

  var addEvent = () => {
    var scrollTopButtons = document.querySelectorAll('[data-scroll-top-sold-out]');

    scrollTopButtons.forEach( btn => btn.addEventListener('click', scrollTop));
  }

  document.body.addEventListener("section_loaded:product_sticky_add", addEvent);

  var updateVisability = (e) => {
    var variant = e.detail.selectedVariant;
    var btnContainers = document.querySelectorAll('.product-page__quickbuy--buy-button');
    var addOnTriggers = document.querySelectorAll('wdn-product-addon [data-trigger]');
    
    if(!variant || btnContainers.length === 0) return;
    var sold_out = variant.inventory_quantity > 0 ? false : true;

    btnContainers.forEach( container => {
      var containsClass = container.classList.contains('product-page__display--sold-out');
      addOnTriggers.forEach( trigger => trigger.setAttribute('data-state', sold_out ? 'sold_out' : 'default'));
      
      if (!sold_out && containsClass) container.classList.remove('product-page__display--sold-out');
      if (sold_out && !containsClass) container.classList.add('product-page__display--sold-out');
    });
  }

  document.body.addEventListener('variant:selected', updateVisability);
})();

/* Product Gallery magnifier hover  */

if (typeof WDN.ZoomImage === "undefined") {
  WDN.ZoomImage = (function () {
    var ZoomImage;
    var _debounce = WDN.Debounce;

    var config = {
      image_attribute: "data-image-zoom",
      zoom: 2,
      debounce_wait: 4, // mousemove debounce ms
      allowOnMobile: false,
    };

    ZoomImage = function (externalConfig) {
      this.id = externalConfig.id;
      this.externalConfig = externalConfig || {};
      this.parentElement = document.querySelector("[" + config.image_attribute + '="' + this.id + '"]');
      this.image = this.parentElement.querySelector("img");
      this.isLazyloaded = this.isImageLoaded();
      this.preloaded = false;
      this.magnifier = {
        element: this.parentElement.querySelector("[data-magnifier-src]"),
        width: "", // Will be populated dynamically
        height: "",
        src: "",
        bgWidth: 4,
        isLazyloaded: false,
      };

      if (!this.isLazyloaded) {
        this.listenForImageLoad();
        return;
      }
      this.init();
    };

    ZoomImage.prototype.isImageLoaded = function () {
      return this.image.complete && this.image.naturalHeight !== 0;
    };

    ZoomImage.prototype.validateConfig = function () {
      if (!config.allowOnMobile) {
        this.magnifier.element.classList.add("magnifier--disabledOnPhone");
      }
    };

    ZoomImage.prototype.getCursorPosition = function (e) {
      e = e || window.event;
      var xPos = 0;
      var yPos = 0;
      var imgDomRec = this.image.getBoundingClientRect();
      xPos = e.pageX - imgDomRec.left - window.pageXOffset;
      yPos = e.pageY - imgDomRec.top - window.pageYOffset;
      return { x: xPos, y: yPos };
    };

    ZoomImage.prototype.onMove = function (e) {
      e ? e.preventDefault() : "";

      this.validateBackgroundImage();
      this.cursorPos = this.getCursorPosition(e);
      // calculates magnifier position based on cursor
      this.calculateMagnifierPosition();
      // moves background position based on magnifier calculation
      this.moveMagnifierBackground();
    };

    ZoomImage.prototype.lazyLoadMagnifier = function () {
      // Creating hidden div
      var hiddenDiv = document.createElement("div");
      hiddenDiv.classList.add("ghost");
      // Creating image tag that will lazyload magnifier background
      var imageTag = document.createElement("img");
      imageTag.setAttribute("src", this.magnifier.src);
      imageTag.setAttribute("loading", "lazy");
      // Appending image to hidden div
      hiddenDiv.appendChild(imageTag);

      this.magnifier.imageContainer = hiddenDiv;
      this.magnifier.imageTag = imageTag;

      // Appending hidden div to magnifier
      this.magnifier.output.appendChild(hiddenDiv);
    };

    ZoomImage.prototype.assignMagnifierOutput = function () {
      this.magnifier.output = this.magnifier.element;
      if (this.externalConfig && this.externalConfig.staticOutput) {
        this.magnifier.output = document.querySelector("[data-static-magnifier]");
      }
    };

    ZoomImage.prototype.validateBackgroundImage = function () {
      if (!this.magnifier.isRendered) {
        this.assignMagnifierOutput();
        this.appendMagnifierBackground();
        // Creates lazyload of full quality magnifier image
        this.lazyLoadMagnifier();
        // Listenes for magnifier image to load, replaces the previous low quality source
        this.listenForMagnifierLazyLoad();
        this.magnifier.isRendered = true;
      }
    };

    ZoomImage.prototype.getBackgroundSize = function () {
      return this.image.width * config.zoom + "px " + this.image.height * config.zoom + "px";
    };

    ZoomImage.prototype.assignMagnifierBackground = function () {
      var elementStyle = this.magnifier.output.style;
      var backgroundSize = this.getBackgroundSize();
      elementStyle.backgroundImage = "url('" + this.image.currentSrc + "')";
      elementStyle.backgroundSize = backgroundSize;
      elementStyle["-webkit-background-size"] = backgroundSize;
    };

    ZoomImage.prototype.appendMagnifierBackground = function () {
      // Assigns Magnifiers bg and bg size based on image calculations
      this.assignMagnifierBackground();
      // Stores magnifier image src, that will be lazyloaded later
      this.magnifier.src = this.magnifier.element.getAttribute("data-magnifier-src");
      // Calculates magnifier's width and height
      this.assignMagnifierProportions();
    };

    ZoomImage.prototype.assignMagnifierProportions = function () {
      this.magnifier.width = this.magnifier.element.offsetWidth / 2;
      this.magnifier.height = this.magnifier.element.offsetHeight / 2;

      this.magnifier.bgOutputWidth = this.magnifier.output.offsetWidth / 2;
      this.magnifier.bgOutputHeight = this.magnifier.output.offsetHeight / 2;
    };

    ZoomImage.prototype.updateMagnifierBackground = function () {
      if (this.magnifier.output.getAttribute("data-active-src") === this.magnifier.imageTag.currentSrc) {
        this.magnifier.output.classList.add("loaded");
        return;
      }

      // Takes hidden lazyloaded image's src and applies to Magnifier background
      this.magnifier.output.style.backgroundImage = "url('" + this.magnifier.imageTag.currentSrc + "')";
      this.magnifier.output.setAttribute("data-active-src", this.magnifier.imageTag.currentSrc);
      this.magnifier.isLazyloaded = true;
      this.magnifier.output.classList.add("loaded");
    };

    ZoomImage.prototype.magnifierActive = function (state) {
      var action = "add";
      if (!state) {
        action = "remove";
      }
      if (!this.magnifier.output) return;
      this.magnifier.output.classList[action]("magnifier--active");
    };

    ZoomImage.prototype.moveMagnifierBackground = function () {
      this.updateMagnifierBackground();
      // Moves magnifier itself
      this.magnifier.element.style.left = this.cursorPos.x - this.magnifier.width + "px";
      this.magnifier.element.style.top = this.cursorPos.y - this.magnifier.height + "px";
      // Moves background for static magnifier
      if (this.externalConfig.staticOutput) {
        var xPos = this.cursorPos.x * config.zoom - this.magnifier.bgOutputWidth + this.magnifier.bgWidth;
        var yPos = this.cursorPos.y * config.zoom - this.magnifier.bgOutputHeight + this.magnifier.bgWidth;
      } else {
        // moves background for dynamic magnifier
        var xPos = this.cursorPos.x * config.zoom - this.magnifier.width + this.magnifier.bgWidth;
        var yPos = this.cursorPos.y * config.zoom - this.magnifier.height + this.magnifier.bgWidth;
      }

      this.magnifier.output.style.backgroundPosition = "-" + xPos + "px -" + yPos + "px";
    };

    ZoomImage.prototype.calculateMagnifierPosition = function () {
      var cursor = this.cursorPos;
      var xPos1 = this.image.width - this.magnifier.width / config.zoom;
      var xPos2 = this.magnifier.width / config.zoom;
      var yPos1 = this.image.height - this.magnifier.height / config.zoom;
      var yPos2 = this.magnifier.height / config.zoom;
      // Checking if magnifier is within image
      if (cursor.x > xPos1) {
        cursor.x = xPos1;
      }
      if (cursor.x < xPos2) {
        cursor.x = xPos2;
      }
      if (cursor.y > yPos1) {
        cursor.y = yPos1;
      }
      if (cursor.y < yPos2) {
        cursor.y = yPos2;
      }
    };

    ZoomImage.prototype.onMagnifierLoad = function () {
      this.magnifier.imageTag.removeEventListener("load", this.onLazyLoadBound);
      // Replaces current background img src with dynamically lazyloaded one
      this.updateMagnifierBackground();
      // Removes hidden container + lazyloaded image
      this.magnifier.imageContainer.remove();
    };

    ZoomImage.prototype.listenForMagnifierLazyLoad = function () {
      this.onMagnifierLoadBound = this.onMagnifierLoad.bind(this);
      this.magnifier.imageTag.addEventListener("load", this.onMagnifierLoadBound);
    };

    ZoomImage.prototype.bindMagnifier = function () {
      this.magnifier.element.addEventListener("mousemove", this.onMoveBound);
      if (config.allowOnMobile) {
        this.magnifier.element.addEventListener("touchmove", this.onMoveBound);
      }
    };

    ZoomImage.prototype.bindImage = function () {
      this.image.addEventListener("mousemove", this.onMoveBound);
      if (config.allowOnMobile) {
        this.image.addEventListener("touchmove", this.onMoveBound);
      }
    };

    ZoomImage.prototype.bind = function () {
      this.onMoveBound = _debounce(this.onMove.bind(this), config.debounce_wait);
      this.onMouseOverBound = this.onMouseOver.bind(this);
      this.image.addEventListener("mouseover", this.onMouseOverBound);
      this.bindMagnifier();
      this.bindImage();
    };

    ZoomImage.prototype.onMouseOver = function () {
      if (this.preloaded) return;
      this.preloadImage();
      this.image.removeEventListener("mouseover", this.onMouseOverBound);
    };

    ZoomImage.prototype.listenForImageLoad = function () {
      this.image.addEventListener("load", this.init.bind(this));
    };

    ZoomImage.prototype.preloadImage = function () {
      var image = new Image();
      image.src = this.magnifier.element.getAttribute("data-magnifier-src");
      this.preloaded = true;
    };

    ZoomImage.prototype.init = function () {
      // Validates Config choices and applies it for further scripting
      this.validateConfig();
      this.bind();
    };

    return ZoomImage;
  })();
}

if (typeof WDN.ZoomImages === "undefined") {
  WDN.ZoomImages = (function () {
    var init;
    var ZoomImage = WDN.ZoomImage;
    var config = {
      image_attribute: "data-image-zoom",
    };

    var nodes = {
      images: false,
      magnifier_images_container: false,
      static_magnifier: false,
      product_page_swiper: false,
    };

    var imageList = {};

    var createImages = function () {
      nodes.images.forEach(function (image) {
        var id = image.getAttribute(config.image_attribute);
        imageList[id] = new ZoomImage({
          id: id,
          staticOutput: true,
        });
      });
    };

    var static_magnifier_active = function (state) {
      var action = "add";
      if (!state) {
        action = "remove";
      }

      nodes.static_magnifier.classList[action]("magnifier--active");
    };

    var getActiveSwiperSlide = function () {
      return nodes.product_page_swiper.Swiper.slides[nodes.product_page_swiper.Swiper.activeIndex];
    };

    var onMouseLeave = function () {
      if (!nodes.product_page_swiper.isCreated) return;
      static_magnifier_active(false);
    };

    var onMouseOver = function () {
      if (!nodes.product_page_swiper.isCreated) return;
      var active_slide = getActiveSwiperSlide();
      static_magnifier_active(active_slide.getAttribute("data-media-type") === "image");
    };

    var listenForSlideChange = function () {
      nodes.product_page_swiper.Swiper.on("slideChange", function () {
        nodes.static_magnifier.classList.remove("loaded");
        var active_slide = getActiveSwiperSlide();
        static_magnifier_active(active_slide.getAttribute("data-media-type") === "image");
      });
    };

    var bind = function () {
      nodes.magnifier_images_container.addEventListener("mouseover", onMouseOver);
      nodes.magnifier_images_container.addEventListener("mouseleave", onMouseLeave);

      if (!nodes.product_page_swiper.isCreated) {
        nodes.product_page_swiper.addEventListener("swiper:created", listenForSlideChange);
        return;
      }

      listenForSlideChange();
    };

    var assignNodes = function () {
      nodes = {
        images: document.querySelectorAll("[" + config.image_attribute + "]"),
        magnifier_images_container: document.querySelector("[data-magnifier-images]"),
        static_magnifier: document.querySelector("[data-static-magnifier]"),
        product_page_swiper: document.querySelector("[data-id='product_page']"),
      };
    };

    init = function () {
      assignNodes();
      createImages();
      bind();
    };

    return {
      init: init,
      list: imageList,
    };
  })();
}

/* Mobile zoom gallery */
(function () {
  var init, getRequestURL, sendRequest, handleRequestError, handleRequestSuccesss;

  // dependencies
  var Request = WDN.Request;

  var config = {
    section_id: "zoom-gallery",
  };

  var nodes = {
    output: document.querySelector("[data-zoom-gallery-target]"),
  };

  handleRequestSuccesss = function (res) {
    nodes.output.insertAdjacentHTML("beforeend", res);
    document.dispatchEvent(
      new CustomEvent("zoomgallery:loaded", {
        bubbles: true,
      })
    );
  };
  handleRequestError = function (res) {
    console.log("handleRequestError", res);
  };

  getRequestURL = function () {
    var searchParams = new URLSearchParams(window.location.search);
    searchParams.set("section_id", config.section_id);
    return location.pathname + "?" + searchParams.toString();
  };

  sendRequest = function () {
    var url = getRequestURL();
    Request.Get({
      url: url,
      onSuccess: handleRequestSuccesss,
      onError: handleRequestError,
    });
  };

  init = function () {
    if (!nodes.output) return;

    document.querySelectorAll("#product_page .swiper-slide").forEach((slide) => {
      slide.addEventListener("click", () => {
        if (window.innerWidth > 880) return;
        if (nodes.output.childNodes.length == 0) sendRequest();
        else
          slide.dispatchEvent(
            new CustomEvent("zoomgallery:display", {
              bubbles: true,
            })
          );
      });
    });
  };

  init();
})();

(function () {
  document.addEventListener("zoomgallery:loaded", function () {
    var galleries = document.querySelectorAll(".section__zoom-gallery");

    galleries.forEach((gallery) => {
      var main = gallery.querySelector("[data-zoom-gallery]"),
        stateBtn = gallery.querySelector("[data-zoom-state]"),
        closeBtn = gallery.querySelector("[data-zoom-close]"),
        slider = gallery.querySelector("[data-zoom-slider]"),
        zoomBox = gallery.querySelector("[data-zoom-box]"),
        zoomIMG = gallery.querySelector("[data-zoom-img-container] img"),
        zoomIndexSpan = gallery.querySelector("[data-zoom-gallery-index]"),
        scale = "scale(3)",
        transform = [0, 0],
        position = [0, 0],
        mousedown = false,
        active = false;

      document.body.setAttribute("data-active-zoom-gallery", "");

      // Slider
      var right = gallery.querySelector("[data-zoom-slide-right]");
      var left = gallery.querySelector("[data-zoom-slide-left]");
      var movingPart = gallery.querySelector("[data-zoom-moving-part]");
      var slides = gallery.querySelectorAll("[data-zoom-slide]");
      var slideIndex = 0;

      var changeZoomImage = function (nr) {
        let img = zoomIMG;
        let aspect = gallery.querySelector("[data-zoom-aspect]");
        let newImg = slides[nr].querySelector("[data-zoom-image-src]").value;
        let newAspect = slides[nr].querySelector("[data-zoom-image-aspect]").value;
        img.src = newImg;
        aspect.value = newAspect;
      };

      var slideController = function (direction) {
        right.removeAttribute("disabled");
        left.removeAttribute("disabled");
        if (direction == "right") slideIndex++;
        if (direction == "left") slideIndex--;

        if (slideIndex < 0) slideIndex = 0;
        if (slideIndex > slides.length - 1) slideIndex = slides.length - 1;

        if (slideIndex == 0) left.setAttribute("disabled", "");
        if (slideIndex == slides.length - 1) right.setAttribute("disabled", "");

        let movement = (100 / slides.length) * slideIndex;
        changeZoomImage(slideIndex);
        zoomIndexSpan.textContent = slideIndex + 1;
        movingPart.style.transform = "translateX(-" + movement + "%)";
      };

      var sliderButtons = function () {
        if (!right || !left) return;

        right.addEventListener("click", () => slideController("right"));
        left.addEventListener("click", () => slideController("left"));
      };
      sliderButtons();

      // Zoom / Swiper

      var clickEvents = function (event) {
        let type = event.type;
        let x = event.clientX;
        let y = event.clientY;
        if (type == "touchstart" || type == "touchmove") {
          x = event.touches[0].clientX;
          y = event.touches[0].clientY;
        }

        if (type == "mousedown" || type == "touchstart") {
          mousedown = true;
          position = [x, y];
        }

        if (type == "mouseup" || type == "touchend") {
          mousedown = false;

          if (!active) {
            let endCheck = type == "touchend" ? event.changedTouches[0].clientX : event.clientX;

            if (Math.abs(endCheck - position[0]) < 5) return;

            position[0] > endCheck ? slideController("right") : slideController("left");
          }
        }

        if ((type == "mousemove" && mousedown) || (type == "touchmove" && mousedown)) {
          event.preventDefault();
        }

        if (active) {
          if ((type == "mousemove" && mousedown) || (type == "touchmove" && mousedown)) {
            let target = zoomIMG;
            let targetFormat = target.getBoundingClientRect();
            let targetAspect = Number(gallery.querySelector("[data-zoom-aspect]").value);
            let windowFormat = [window.innerWidth, window.innerHeight];
            let windowAspect = windowFormat[0] / windowFormat[1];

            var max = {
              width: windowAspect < targetAspect ? (targetFormat.width - windowFormat[0]) / 2 : (targetFormat.height * targetAspect - windowFormat[0]) / 2,
              height: windowAspect < targetAspect ? (targetFormat.width / targetAspect - windowFormat[1]) / 2 : (targetFormat.height - windowFormat[1]) / 2,
            };

            var newX = transform[0] - (position[0] - x);
            var newY = transform[1] - (position[1] - y);

            var maxValue = function (nr, max) {
              let maxValue = max < 0 ? 0 : max;
              var allowed = Math.abs(nr) > maxValue ? maxValue : nr;

              var sign = Math.sign(nr);

              if (sign === 1 || sign === 0) {
                return Math.abs(allowed);
              }

              if (sign === -1 || sign === -0) {
                return -Math.abs(allowed);
              }
            };

            newX = maxValue(newX, max.width);
            newY = maxValue(newY, max.height);

            target.style.transform = `translate(${newX}px,${newY}px) ${scale}`;
            position = [x, y];
            transform = [newX, newY];
          }
        }
      };

      var zoomBoxEvents = function (box) {
        if (!box) return;

        box.addEventListener("touchstart", (event) => clickEvents(event));
        box.addEventListener("touchend", (event) => clickEvents(event));
        box.addEventListener("touchmove", (event) => clickEvents(event));
        box.addEventListener("mousedown", (event) => clickEvents(event));
        box.addEventListener("mouseup", (event) => clickEvents(event));
        box.addEventListener("mousemove", (event) => clickEvents(event));
      };
      zoomBoxEvents(zoomIMG);

      var zoomReset = function (box, btn) {
        active = false;
        box.removeAttribute("data-active");
        main.removeAttribute("data-active");
        btn.innerText = btn.getAttribute("data-zoom-in");
        zoomIMG.removeAttribute("style");
        position = [0, 0];
        transform = [0, 0];
      };

      var zoomBegin = function (box, btn) {
        active = true;
        box.setAttribute("data-active", "");
        main.setAttribute("data-active", "");
        btn.innerText = btn.getAttribute("data-zoom-out");
        setTimeout(() => {
          zoomIMG.style.transition = "none";
        }, 300);
      };

      var zoomBoxState = function (btn, box) {
        if (!btn || !box) return;

        btn.addEventListener("click", (event) => {
          box.hasAttribute("data-active") ? zoomReset(box, btn) : zoomBegin(box, btn);
        });
      };
      zoomBoxState(stateBtn, zoomBox);

      var closeGallery = function (btn) {
        if (!btn) return;

        btn.addEventListener("click", () => {
          if (main.hasAttribute("data-closed")) {
            main.removeAttribute("data-closed");
            document.body.setAttribute("data-active-zoom-gallery", "");
          } else {
            main.setAttribute("data-closed", "");
            document.body.removeAttribute("data-active-zoom-gallery");
          }
        });
      };
      closeGallery(closeBtn);

      document.addEventListener("zoomgallery:display", () => {
        if (main.hasAttribute("data-closed")) {
          main.removeAttribute("data-closed");
          document.body.setAttribute("data-active-zoom-gallery", "");
        } else {
          main.setAttribute("data-closed", "");
          document.body.removeAttribute("data-active-zoom-gallery");
        }
      });
    });
  });
})();

/* Size guide async  */
if (typeof WDN.ProductSizeGuide === "undefined") {
  WDN.ProductSizeGuide = (function () {
    var handleSizeGuideInject = function () {
      var contentParent = document.querySelector("[data-prosize-active]");

      var findContentById = function (id) {
        var targ = document.querySelector('[data-prosize="' + id + '"]');

        if (!targ) {
          return false;
        }

        return targ;
      };

      var handleViewChange = function () {
        var id = this.getAttribute("data-prosize-control");

        if (!id) {
          return;
        }

        var contentToShow = findContentById(id);

        // if aint valid, ignore
        if (!contentToShow) {
          return;
        }

        contentParent.setAttribute("data-prosize-active", id);
      };

      var controllerList = document.querySelectorAll("[data-prosize-control]");

      controllerList.forEach(function (controller) {
        controller.addEventListener("click", handleViewChange);
      });
    };

    /* INIT  */
    new WDN.SectionRenderer({
      selectors: {
        trigger: "wdn-modal-open[data-id='product-size-visual']",
        output: "[data-sizeguide-modal-content]",
      },
      sections: ["async-product-size-modal"],
      useCurrentRoot: true,
      replaceOutput: true,
      events: ["click", "mouseover"],
      callback: handleSizeGuideInject,
    });

    return { handleSizeGuideInject };
  })();
}

/* Mobile quantity modal async  */
(function () {
  /* INIT  */
  new WDN.SectionRenderer({
    selectors: {
      trigger: "wdn-modal-open[data-id='product_quantity']",
      output: "[data-quantity-modal-content]",
    },
    sections: ["async-product-quantity-modal"],
    useCurrentRoot: true,
    replaceOutput: true,
    events: ["click"],
  });
})();

/* Product addons asnyc */
(function () {
  new WDN.SectionRenderer({
    selectors: {
      output: "[data-product-addons-content]",
    },
    sections: ["async-product-addons"],
    replaceOutput: true,
    useCurrentRoot: true,
    triggers: [window],
    events: ["load"],
  });
})();

/* Size guide table async */
(function () {
  new WDN.SectionRenderer({
    selectors: {
      output: "[data-product-sizeguide-content]",
    },
    sections: ["async-product-sizeguide"],
    replaceOutput: true,
    useCurrentRoot: true,
    triggers: [window],
    events: ["load"],
  });
})();

/* Modals async - Guarantee, delivery, returns, contact  */
(function () {
  // Guarantee
  new WDN.SectionRenderer({
    selectors: {
      trigger: "wdn-modal-open[data-id='product_guarantee']",
      output: "[data-guarantee-modal-content]",
    },
    sections: ["price-guarantee-modal"],
    events: ["click", "mouseover"],
  });

  // Delivery
  new WDN.SectionRenderer({
    selectors: {
      trigger: "wdn-modal-open[data-id='delivery_options']",
      output: "[data-delivery-modal-content]",
    },
    sections: ["delivery-options"],
    events: ["click", "mouseover"],
  });

  // Returns
  new WDN.SectionRenderer({
    selectors: {
      trigger: "wdn-modal-open[data-id='product_returns']",
      output: "[data-returns-modal-content]",
    },
    sections: ["returns-modal"],
    events: ["click", "mouseover"],
  });

  // Contact
  new WDN.SectionRenderer({
    selectors: {
      trigger: "wdn-modal-open[data-id='product_contact']",
      output: "[data-contact-modal-content]",
    },
    sections: ["contact-modal"],
    events: ["click", "mouseover"],
  });
})();
